import 'core-js/stable/index.js';
import 'regenerator-runtime/runtime.js';
// import 'whatwg-fetch';
/* Disabled due to issues with Chrome and IntersectionObserver API, use lazysizes instead of lozad/intersection-observer */
/*
import 'intersection-observer';
*/
import 'lazysizes';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.throttleDelay = 66;
window.lazySizesConfig.loadMode = 2;
window.lazySizesConfig.ricTimeout = 150;

/* eslint-disable no-bitwise */
if (!window.crypto.randomUUID)
	crypto.randomUUID = () =>
		([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
			(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
		);
